export const environment = {
	production: true,
	apiKey: "5d46e2e019e07e3456a7f1257caeef75",
	apiUrl: "https://api.openweathermap.org/data/2.5",
	name: "prod",
	environmentId: 1
};
